import NewsletterSignupForm from "@blocks/NewsletterSignupForm/NewsletterSignupForm";
import MainBlock from "@container/MainBlock";
import MainContainer from "@container/MainContainer";
import SideBlock from "@container/SideBlock/SideBlock";
import WrapperBlock from "@container/WrapperBlock";
import { useMobWebView } from "@hooks/useMobWebView";
import { NewsletterMetaData } from "@pages/Newsletter/NewsletterMetaData";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";

export default function Newsletter() {
  const mobwebviewBool = useMobWebView();
  const pageAdTargetValue = PageAdTargetingTypeEnum.LISTING;
  const sectionName = "newsletter-signup";
  const { gaData, metaTags } = NewsletterMetaData({
    sectionName,
  });

  return (
    <MainContainer
      gaData={gaData}
      metaTagsProps={metaTags}
      sectionName={sectionName}
      mobwebview={mobwebviewBool}
      pageAdTargetValue={pageAdTargetValue}
    >
      <WrapperBlock className="flex flex-col lg:flex-row justify-between">
        <MainBlock pageName={sectionName} showTitle={false}>
          <div className="flex flex-wrap">
            <h5 className="text-md font-bold leading-600 mb-2">
              எங்களுடன் இணைந்திருங்கள்!
            </h5>
            <NewsletterSignupForm mobwebview={mobwebviewBool} />
          </div>
        </MainBlock>
        {!mobwebviewBool && (
          <SideBlock
            sectionName={sectionName}
            className="w-full lg:block"
            pageAdTargetValue={pageAdTargetValue}
          />
        )}
      </WrapperBlock>
    </MainContainer>
  );
}
